module.exports = "favicons/apple-touch-icon-57x57.png";